import React, { useEffect, useRef } from 'react';
import { FullScreenModalTrigger } from '@atlassian/entry-points/full-screen-modal-trigger';
import { mergeRefs } from '@atlassian/jira-merge-refs';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';
import { RovoAiProjectModalLoadingFallback } from './RovoAiProjectPermissionModal.tsx';
import { rovoAiProjectSpotlightModalEntryPoint } from './RovoAiProjectSpotlightModal.entrypoint.tsx';

export const SOLCOM_GET_STARTED_EVENT = 'solcom-create-space-spotlight:get-started';

const emptyEntryPointParams = {};
const emptyEntryPointProps = {};

function RovoAiProjectModalListenerEnabled(): React.JSX.Element {
	const triggerRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (!globalThis.window) {
			return;
		}
		const handleGetStarted = () => {
			triggerRef.current?.click();
		};
		globalThis.window.addEventListener(SOLCOM_GET_STARTED_EVENT, handleGetStarted);
		return () => {
			globalThis.window.removeEventListener(SOLCOM_GET_STARTED_EVENT, handleGetStarted);
		};
	}, []);

	return (
		<FullScreenModalTrigger
			entryPoint={rovoAiProjectSpotlightModalEntryPoint}
			entryPointParams={emptyEntryPointParams}
			entryPointProps={emptyEntryPointProps}
			Fallback={RovoAiProjectModalLoadingFallback}
		>
			{({ ref }) => <span ref={mergeRefs(ref, triggerRef)} aria-hidden="true" hidden />}
		</FullScreenModalTrigger>
	);
}

function RovoAiProjectModalListenerDisabled(): React.JSX.Element {
	return <></>;
}

export const RovoAiProjectModalListener: React.ComponentType = componentWithFG(
	'solcom_create_space_jira_admin_spotlight',
	RovoAiProjectModalListenerEnabled,
	RovoAiProjectModalListenerDisabled,
);
